export default "__VITE_ASSET__BRkIf5x7__"